
import { deleteMatchFincaProv, getUrlServs } from "../services";
import Swal from "sweetalert2";
import { toast } from "react-toastify";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";

import { deleteComment, fixComment, updateComment } from "../services/comment.service";
import Resizer from 'react-image-file-resizer';
import i18n from "../i18n";

const t = (key) => i18n.t(key, { ns: 'common' });

const normalizeText = (text) => {
  return text
    .toLowerCase()
    .normalize("NFD") // descompone letras con tilde en letra + tilde
    .replace(/[\u0300-\u036f]/g, "") // elimina los acentos
    .replace(/\s+/g, " ") // reemplaza múltiples espacios por uno
    .trim();
};

export const filterItemsCustom = (query, array) => {
  const normalizedQuery = normalizeText(query);

  return array.filter((el) => {
    const nombre = normalizeText(el.nombre);
    const apellidos = normalizeText(el.apellidos);
    const busqueda = normalizeText(el.busqueda);

    return (
      nombre.includes(normalizedQuery) ||
      apellidos.includes(normalizedQuery) ||
      busqueda.includes(normalizedQuery)
    );
  });
};


export const filterItems = (query, array) => {
 
  return array.filter(function (el) {
    return el.busqueda.toLowerCase().indexOf(query.toLowerCase()) > -1;
  });
};

export const formatoFechas = (fecha) => {
  var d = new Date(fecha);
  var mm = d.getMonth() + 1 < 10 ? "0" + (d.getMonth() + 1) : d.getMonth() + 1;
  var dd = d.getDate() < 10 ? "0" + d.getDate() : d.getDate();
  var yy = d.getFullYear();
  let nuevoFormato = yy + "-" + mm + "-" + dd;

  return nuevoFormato;
};

export const formatoFechasEs = (fecha) => {
  var d = new Date(fecha);
  var mm = d.getMonth() + 1 < 10 ? "0" + (d.getMonth() + 1) : d.getMonth() + 1;
  var dd = d.getDate() < 10 ? "0" + d.getDate() : d.getDate();
  var yy = d.getFullYear();
  let nuevoFormato = dd + "-" + mm + "-" + yy;

  return nuevoFormato;
};

export const monthDiff = (dateFrom, dateTo) => {
  return (
    dateTo.getMonth() -
    dateFrom.getMonth() +
    12 * (dateTo.getFullYear() - dateFrom.getFullYear())
  );
};

export const daysDiff = (dateFrom, dateTo) => {
  var diasdif = dateTo.getTime() - dateFrom.getTime();
  var contdias = Math.round(diasdif / (1000 * 60 * 60 * 24)); 
  return contdias;
};

export const eliminaDuplicados = (arr) => {
  const setObj = new Set(); 

  return arr.reduce((acc, elemento) => {
    const clave = JSON.stringify(elemento.id);

    if (!setObj.has(clave)) {
      setObj.add(clave, elemento);
      acc.push(elemento);
    }
    return acc;
  }, []);
};



export const subirDeclaracionResponsable = () => {
  console.log("subirDeclaracionResponsable");
};
export const verDocumentacionProveedor = () => {
  console.log("verDocumentacionProveedor");
};
export const validarDocumentacion = () => {
  console.log("validarDocumentacion");
};
export const noValidarDocumentacion = () => {
  console.log("noValidarDocumentacion");
};

export const verDocumentacion = () => {
  console.log("verDocumentacion");
};

export const comprobarDocumentacion = () => {
  console.log("comprobarDocumentacion");
};

export const subirDocumentacion = () => {
  console.log("subirDocumentacion");
  var el = document.getElementById("fileElem");
  el.click();
};

export const desvincularProveedor = (idFinca, idProveedor, aaff_id) => {
  return new Promise(async (resolve, reject) => {
    try {
  
      Swal.fire({
        title: t('suppliers.messages.unlinkSupplierQuestion'),
        showCancelButton: true,
        confirmButtonText: t('suppliers.messages.unlink'),
        confirmButtonColor: "#49cd70",
      }).then((result) => {

        if (result.isConfirmed) {

          deleteMatchFincaProv(idFinca, idProveedor, aaff_id)
            .then((res) => {

              if (res.status >= 200 && res.status < 300) {
                toast.success(t('suppliers.messages.supplierUnlinked'));
                resolve(true);
              } else {
                toast.error(
                  t('suppliers.messages.couldNotUnlinkSupplierWithId', { id: idProveedor })
                );
              }
            })
            .catch((error) => {
              console.log(error);
              toast.error(t('suppliers.messages.errorOccurred'));
            });
        }
      });
    }catch (error) {
      reject(error)
    }
  })
};
export const desvincularProveedorDeFincas = (fincas, idProv, aaff_id) => {
  return new Promise(async (resolve, reject) => {
    try {
      
      Swal.fire({
        title: t('suppliers.messages.unlinkSupplierFromAllQuestion'),
        showCancelButton: true,
        confirmButtonText: t('suppliers.messages.unlink'),
        confirmButtonColor: "#49cd70",
      }).then((result) => {
        /* Read more about isConfirmed, isDenied below */
        if (result.isConfirmed) {

          deleteMatchFincaProv(fincas, idProv, aaff_id)
          .then((res) => {
            if (res.status >= 200 && res.status < 300) {
              toast.success(t('suppliers.messages.supplierUnlinked'));
              resolve(true);
            } else {
              toast.error(
                t('suppliers.messages.couldNotUnlinkFromProperty')
              );
            }
          })
          .catch((error) => {
            console.log(error);
            toast.error(t('suppliers.messages.errorOccurred'));
          });
        }
      });
    }catch (error) {
      reject(error)
    }
  })
};

export const desvincularProveedores = (idFinca, provs, aaff_id) => {
  return new Promise(async (resolve, reject) => {
    try {
      
      Swal.fire({
        title: t('suppliers.messages.unlinkAllSuppliersQuestion'),
        showCancelButton: true,
        confirmButtonText: t('suppliers.messages.unlink'),
        confirmButtonColor: "#49cd70",
      }).then((result) => {
        /* Read more about isConfirmed, isDenied below */
        if (result.isConfirmed) {
          const provsIds = provs.map(p => p.id)
          deleteMatchFincaProv(idFinca, provsIds, aaff_id)
          .then((res) => {
            if (res.status >= 200 && res.status < 300) {
              toast.success(Array.isArray(provsIds) ? t('suppliers.messages.suppliersUnlinked') : t('suppliers.messages.supplierUnlinked'));
              resolve(true);
            } else {
              toast.error(
                t('suppliers.messages.couldNotUnlinkSupplier')
              );
            }
          })
          .catch((error) => {
            console.log(error);
            toast.error(t('suppliers.messages.errorOccurred'));
          });
        }
      });
    }catch (error) {
      reject(error)
    }
  })
};

export const cambiarUltimaReclamacion = () => {
  console.log("cambiarUltimaReclamacion");
};

export const generarPDF = (id) => {
  const input = document.getElementById(id);
  html2canvas(input).then((canvas) => {
    const imgData = canvas.toDataURL("image/png");
    const pdf = new jsPDF("p", "mm", "a4");
    const pageWidth = pdf.internal.pageSize.getWidth();
    const pageHeight = pdf.internal.pageSize.getHeight();
    const imageWidth = canvas.width;
    const imageHeight = canvas.height;
    const ratio = Math.min(pageWidth / imageWidth, pageHeight / imageHeight);
    const centerImageWidth = imageWidth * ratio;
    const centerImageHeight = imageHeight * ratio;
    const leftPosition = (pageWidth - centerImageWidth) / 2;
    const topPosition = (pageHeight - centerImageHeight) / 2;
    pdf.addImage(
      imgData,
      "PNG",
      leftPosition,
      topPosition,
      centerImageWidth,
      centerImageHeight
    );
    pdf.save("file.pdf");
  });
};

export const numProveedoresAAFF = (data) => {
  //sumar todos los proveedores unicos de un aaaff
  const nifUnicos = [...new Set(data.reduce((acumulador, objeto) => {
      objeto.suppliers.forEach(supplier => {
        if(supplier.status){
          acumulador.push(supplier.nif);
        }
      });
      return acumulador;
    }, []))];
    
    return nifUnicos;
  
}
export const docsPendientesProvs = (data) => {
  const pendientesDocs = data
    .map((elemento) =>
      elemento.suppliers.map((proveedor) =>
        proveedor.docssupps.filter((docssupp) => docssupp.pendiente === true).length
      )
    )
    .flat(2)
    .reduce((total, count) => total + count, 0);
  const pendientesDeclRes = data
    .map((elemento) =>
      elemento.suppliers.map((proveedor) =>
        proveedor.docssupps.filter((dr) => dr.pendiente === true).length
      )
    )
    .flat(2)
    .reduce((total, count) => total + count, 0);
  const conteoPendientes = pendientesDocs + pendientesDeclRes
  return conteoPendientes;
  
}
export const docsPendientesProv = (data) => {
  console.log(data)
  const pendientesDocs = data.docssupps?.filter((docssupp) => docssupp.pendiente === true).length || 0
  const pendientesDeclRes = data.declres?.filter((dr) => dr.pendiente === true).length || 0
  const conteoPendientes = pendientesDocs + pendientesDeclRes
  console.log(data.nif, pendientesDocs, pendientesDeclRes)
  return conteoPendientes;
}

export const municipiosIniciales = (provinces, municipalities, provincia) => {
  let municipios = []
  let codProvincia = ''
  provinces.map( p => {
    if(p.name === provincia){
      codProvincia = p.code
    }
  })
  municipalities.map( m => {
    if(m.provCode === codProvincia){
      
      municipios.push({...m, name: cambiarFormatoNombre(m.name), value: m.name})
    }
  })
  return municipios
}

export const cambiarFormatoNombre = (nombre) => {
  
  if (nombre?.includes(",")) {
    const partes = nombre.split(", ");
    if (partes.length === 2) {
      
      return partes[1] + " " + partes[0];
    }
  }
  
  return nombre;
}

export const eliminarComentario = (id) => {
  return new Promise(async (resolve, reject) => {
    try {
      Swal.fire({
        title: t('comments.deleteQuestion'),
        showCancelButton: true,
        confirmButtonText: t('actions.delete'),
        confirmButtonColor: "#892828",
      }).then((result) => {

        if (result.isConfirmed) {
          deleteComment(id)
          .then((res) => {
            if (res.status >= 200 && res.status < 300) {
              toast.success(t('comments.deleted'));
              resolve(true);
            } else {
              toast.error(
                t('comments.couldNotDelete')
              );
            }
          })
          .catch((error) => {
            console.log(error);
            toast.error(t('suppliers.messages.errorOccurred'));
          });
        }
      });
    }catch (error) {
      reject(error)
    }
  })
}
export const fijarComentario = (id, fijar) => {
  return new Promise(async (resolve, reject) => {
    try {
      fixComment(id, fijar)
          .then((res) => {
            if (res.status >= 200 && res.status < 300) {
              toast.success(t('comments.pinned'));
              resolve(true);
            } else {
              toast.error(
                t('comments.couldNotPin')
              );
            }
          })
          .catch((error) => {
            console.log(error);
            toast.error(t('suppliers.messages.errorOccurred'));
          });
    }catch (error) {
      reject(error)
    }
  })
}
export const editarComentario = (id, userId, comm) => {
  return new Promise(async (resolve, reject) => {
    try {
      let toastInfo = undefined
      Swal.fire({
        title: t('comments.editTitle'),
        showCancelButton: true,
        confirmButtonText: t('comments.edit'),
        confirmButtonColor: "#49cd70",
        html: `<textarea id="comentario" style="width: 100%; height: 600px; border: 1px solid #ccc; border-radius: 5px; padding: 10px;" className="swal2-input">${comm.texto}</textarea>`,

        preConfirm: () => {
          toastInfo = toast.info(t('comments.savingData'), { autoClose: false });
          const comentario = Swal.getPopup().querySelector("#comentario").value;
          if (!comentario) {
            Swal.showValidationMessage(t('comments.commentRequired'));
          }
          const data = {
            prop_id:comm.prop_id,
            supp_id:comm.supp_id,
            aaff_id:comm.aaff_id,
            texto:comentario,
            tipo: comm.tipo
          };
          return { data: data };
        },
      }).then((result) => {

        if (result.isConfirmed) {
          updateComment(id, result.value.data)
          .then((res) => {
            if (res.status >= 200 && res.status < 300) {
              toast.update(toastInfo, {
                render: t('comments.updated'),
                type: toast.TYPE.SUCCESS,
                autoClose: true
              });
              resolve(true);
            } else {
              toast.update(toastInfo, {
                render: t('comments.couldNotUpdate'),
                type: toast.TYPE.ERROR,
                autoClose: true
              });
            }
          })
          .catch((error) => {
            console.log(error);
            toast.error(t('suppliers.messages.errorOccurred'));
          });
        }
      });
    }catch (error) {
      reject(error)
    }
  })
}

export const comprimirImagenOld = (imagenComoArchivo) => {
  console.log("Comprimiendo imagen con método antiguo");
  return new Promise((resolve, reject) => {
    const $canvas = document.createElement("canvas");
    const imagen = new Image();
    imagen.onload = () => {
      $canvas.width = imagen.width;
      $canvas.height = imagen.height;
      $canvas.getContext("2d").drawImage(imagen, 0, 0);
      $canvas.toBlob(
        (blob) => {
          if (blob === null) {
            return reject(blob);
          } else {
            resolve(blob);
          }
        },
        "image/jpeg",
        80 / 100,
      );
    };
    imagen.src = URL.createObjectURL(imagenComoArchivo);
  });
};

const leerArchivoComoBlob = (file, timeoutMs = 25000) =>
  new Promise((resolve, reject) => {
    let terminado = false;
    const reader = new FileReader();
    const timer = setTimeout(() => {
      if (terminado) return;
      terminado = true;
      try { reader.abort(); } catch (_) {}
      reject(new Error('Timeout al leer la imagen'));
    }, timeoutMs);
    reader.onload = () => {
      if (terminado) return;
      terminado = true;
      clearTimeout(timer);
      try {
        const buffer = reader.result;
        const tipo = file.type || 'application/octet-stream';
        resolve(new Blob([buffer], { type: tipo }));
      } catch (e) {
        reject(e);
      }
    };
    reader.onerror = () => {
      if (terminado) return;
      terminado = true;
      clearTimeout(timer);
      reject(new Error('No se pudo leer la imagen'));
    };
    reader.onabort = () => {
      if (terminado) return;
      terminado = true;
      clearTimeout(timer);
      reject(new Error('Lectura de imagen abortada'));
    };
    try {
      reader.readAsArrayBuffer(file);
    } catch (e) {
      if (terminado) return;
      terminado = true;
      clearTimeout(timer);
      reject(e);
    }
  });

const ejecutarResizer = (entrada, opciones) =>
  new Promise((resolve, reject) => {
    const { maxWidth, maxHeight, quality, formato, timeoutMs } = opciones;
    let terminado = false;
    const timer = setTimeout(() => {
      if (terminado) return;
      terminado = true;
      reject(new Error('Timeout al comprimir la imagen'));
    }, timeoutMs);
    try {
      Resizer.imageFileResizer(
        entrada,
        maxWidth,
        maxHeight,
        formato,
        quality,
        0,
        (resultado) => {
          if (terminado) return;
          terminado = true;
          clearTimeout(timer);
          if (!resultado || (resultado.size !== undefined && resultado.size === 0)) {
            reject(new Error('Resultado de compresión vacío'));
            return;
          }
          resolve(resultado);
        },
        'blob',
        undefined,
        undefined
      );
    } catch (err) {
      if (terminado) return;
      terminado = true;
      clearTimeout(timer);
      reject(err);
    }
  });

// Compresión segura (iOS/Safari compatible): usa exclusivamente react-image-file-resizer
// con un timeout y devuelve siempre un File en formato WebP. Pre-lee el archivo con
// FileReader (capturando errores que de otra forma escapan a window.onerror) y
// reintenta con parámetros más conservadores si la decodificación falla por memoria.
export const comprimirImagenSafe = async (imagenComoArchivo, opciones = {}) => {
  const cfg = {
    maxWidth: opciones.maxWidth ?? 1920,
    maxHeight: opciones.maxHeight ?? 1920,
    quality: opciones.quality ?? 80,
    timeoutMs: opciones.timeoutMs ?? 25000,
    formato: opciones.formato ?? 'WEBP',
  };
  const baseName = (imagenComoArchivo?.name || 'imagen').split('.').slice(0, -1).join('.') || 'imagen';
  const extension = cfg.formato === 'JPEG' ? 'jpg' : cfg.formato.toLowerCase();
  const mimeType = cfg.formato === 'JPEG' ? 'image/jpeg' : `image/${cfg.formato.toLowerCase()}`;
  const nombreFinal = `${baseName}.${extension}`;

  // Pre-lee como Blob (captura ProgressEvent que escaparía de Resizer en móvil).
  let blobEntrada;
  try {
    blobEntrada = await leerArchivoComoBlob(imagenComoArchivo, cfg.timeoutMs);
  } catch (err) {
    throw new Error(`No se pudo leer la imagen: ${err.message}`);
  }

  // Re-empaqueta como File para que Resizer mantenga el name.
  const archivoEntrada = new File([blobEntrada], imagenComoArchivo?.name || 'imagen', {
    type: imagenComoArchivo?.type || blobEntrada.type,
  });

  let resultado;
  try {
    resultado = await ejecutarResizer(archivoEntrada, cfg);
  } catch (errPrimero) {
    // Reintento con parámetros más bajos (liberar de memoria en móvil).
    try {
      resultado = await ejecutarResizer(archivoEntrada, {
        ...cfg,
        maxWidth: Math.min(cfg.maxWidth, 1280),
        maxHeight: Math.min(cfg.maxHeight, 1280),
        quality: Math.min(cfg.quality, 70),
        timeoutMs: cfg.timeoutMs,
      });
    } catch (errSegundo) {
      throw new Error(`No se pudo comprimir la imagen (${errSegundo.message || errPrimero.message})`);
    }
  }

  if (resultado instanceof File) {
    return new File([resultado], nombreFinal, { type: resultado.type || mimeType });
  }
  if (resultado instanceof Blob) {
    return new File([resultado], nombreFinal, { type: resultado.type || mimeType });
  }
  return resultado;
};

export const comprimirImagen = async (imagenComoArchivo) => {
  console.log("Comprimiendo imagen con método nuevo 2");
  try {
    const tamañoOriginalMB = (imagenComoArchivo.size / (1024 * 1024)).toFixed(2);
    console.log(`Tamaño original: ${tamañoOriginalMB} MB`);

    return new Promise((resolve, reject) => {
      Resizer.imageFileResizer(
        imagenComoArchivo,
        1920, // maxWidth
        1920, // maxHeight
        'WEBP', // compressFormat
        80, // quality
        0, // rotation
        (compressedFile) => {
          const tamañoComprimidoMB = (compressedFile.size / (1024 * 1024)).toFixed(2);
          console.log(`Tamaño comprimido: ${tamañoComprimidoMB} MB`);
          console.log(`Reducción: ${((1 - compressedFile.size / imagenComoArchivo.size) * 100).toFixed(1)}%`);
          resolve(compressedFile);
        },
        'blob', // outputType
        undefined, // minWidth
        undefined, // minHeight
      );
    });
  } catch (error) {
    throw new Error(`Error al comprimir imagen: ${error.message}`);
  }
};



export function encryptParameters(...params) {
 
  const encryptedParams = params.map(param => btoa(param)).join('/');
  return encryptedParams;
}


export function decryptParameters(encryptedParams) {
 
  const decryptedParams = encryptedParams.split('/').map(param => atob(param));
  return decryptedParams;
}

export function decryptParameter(encryptedParameter) {
  return atob(encryptedParameter);
}

export function diferenciaMesesCaducidad(renovatedDate, createdAt){
  const fechaRenovacion = renovatedDate ? new Date(renovatedDate) : "";
  const fechaCreacion = new Date(createdAt);
  const hoy = new Date();
  const diferenciaMeses = renovatedDate ? (hoy.getFullYear() - fechaRenovacion.getFullYear()) * 12 + (hoy.getMonth() - fechaRenovacion.getMonth()) : (hoy.getFullYear() - fechaCreacion.getFullYear()) * 12 + (hoy.getMonth() - fechaCreacion.getMonth());
  return diferenciaMeses
}

export function estadoServicio(id, t){
  const estados = ['Activa', 'Pdte Renovación', 'Baja vto', 'Baja', 'Anulado'];
  const index = (id === null || id === undefined) ? 0 : id - 1;
  const nombre = estados[index] || 'Estado no válido';
  if (t) {
    return t(`common:stateNames.${nombre}`, nombre);
  }
  return nombre;
}

// Grupos de servicios por servp_id (CAE / LOPD / CAI).
export const GRUPOS_SERVICIO = {
  cae: [1, 3, 6, 7],
  lopd: [2, 4, 5],
  cai: [8, 9],
};

// Devuelve la venta MÁS RECIENTE por id de los grupos de servicio indicados, en una
// sola pasada. No muta el array ni depende de su orden (sustituye a los .reverse()/.find()).
// puede ser cualquier array con { id, servp_id }.
export const ventaMasReciente = (ventas, grupos) =>
  (ventas || []).reduce(
    (masReciente, s) =>
      grupos.includes(s.servp_id) && (masReciente === null || s.id > masReciente.id)
        ? s
        : masReciente,
    null
  );
//Acepta un array de urls y devuelve un array de blobs comprimidos
export const comprimirImagenesDesdeUrls = async (urls, porcentajeCalidad = 70) => {
  const comprimirBlob = (blob) => {
    return new Promise((resolve, reject) => {
      const canvas = document.createElement("canvas");
      const img = new Image();
      img.crossOrigin = "anonymous";
      img.onload = () => {
        canvas.width = img.width;
        canvas.height = img.height;
        canvas.getContext("2d").drawImage(img, 0, 0);
        canvas.toBlob(
          (compressedBlob) => {
            if (!compressedBlob) return reject("No se pudo comprimir");
            resolve(compressedBlob);
          },
          "image/jpeg",
          porcentajeCalidad / 100
        );
      };
      img.onerror = () => reject("No se pudo cargar la imagen");
      img.src = URL.createObjectURL(blob);
    });
  };

  const descargarYComprimir = async (url) => {
    try {
      if (!url || typeof url !== "string") return null;
      const urlLimpia = url.trim();
      if (!urlLimpia || /\/(undefined|null)$/i.test(urlLimpia)) return null;
      const response = await fetch(urlLimpia, { mode: "cors" });
      if (!response.ok) return null;
      const blob = await response.blob();
      if (!blob || !blob.type?.startsWith("image/")) return null;
      const comprimido = await comprimirBlob(blob);
      return comprimido;
    } catch (err) {
      console.error("Error al procesar imagen:", url, err);
      return null;
    }
  };

  const resultados = await Promise.all((urls || []).map((url) => descargarYComprimir(url)));

  // Filtrar nulos por si alguna falló
  return resultados.filter((img) => img !== null);
};

export const getNextDelegacionNif = (allRecords) => {
  const sufijos = allRecords
    .map(d => parseInt(d.nif.replace('DEL', ''), 10))
    .filter(num => !isNaN(num));

  const siguienteNumero = sufijos.length > 0 ? Math.max(...sufijos) + 1 : 1;

  return `DEL${siguienteNumero.toString().padStart(5, '0')}`;
}

    function buildUrl(type, data, saleId) {
      console.log(data)
        const baseUrl = 'Integracces://form';
        const params = [];
        // Buscar registros con group_id 1 (CAE)
        const cae = data[0].cae;
        const cai = data[0].cai;
        const finca = data[0].finca;
        const tecnico = data[0].tecnico_cai;
        const tecnico_cai_id = data[0].tecnico_cai?.id || null;
        const tecnico_cae_id = data[0].tecnico_cae?.id || null;
        // El servicio sobre el que se está actuando: saleId es el id de la venta pulsada.
        const accionEsCae = cae && saleId === cae.id;
        console.log("pruebaaaa", cae, cai, cae && cai && tecnico_cai_id === tecnico_cae_id)
        if (cae && !cai) {
            // console.log('solo cae');
            // params.push(`idCae=${cae.id}`);
            // params.push(`grupo=1`);
        } else if (cai && !cae) {
            // console.log('solo cai');
            params.push(`idCai=${cai.id}`);
            params.push(`grupo=3`);
            type === 'edit' && params.push(`visitSheetCai_id=${cai.visitSheetCai_id}`);
        } else if (cae && cai && tecnico_cai_id === tecnico_cae_id) {
            console.log('ambos existen');
            params.push(`idCae=${cae.id}`);
            params.push(`idCai=${cai.id}`);
            params.push(`grupo=1-3`);
            type === 'edit' && params.push(`visitSheetCai_id=${cai.visitSheetCai_id}`, `visitSheetCae_id=${cae.visitSheet_id}`);
        } else if (cae && cai && tecnico_cai_id !== tecnico_cae_id && !accionEsCae) {
                params.push(`idCai=${cai.id}`);
                params.push(`grupo=3`);
                type === 'edit' && params.push(`visitSheetCai_id=${cai.visitSheetCai_id}`);
        }
        // El objeto ya viene bien estructurado del backend
        const combined = { cae: cae, cai: cai, finca: finca, tecnico: tecnico };
        const json = JSON.stringify(combined);
        const encoded = btoa(unescape(encodeURIComponent(json))); // Para caracteres especiales
        type === 'create' && params.push(`data=${encoded}`);

        return params.length > 0 ? `${baseUrl}?${params.join('&')}` : baseUrl;
    }
export const redirigirApp = async (type, id, saleDate, prop_id, aaff_id, work_id) => {
    try {
      const data = { id: id, saleDate: saleDate.split('T')[0], prop_id: prop_id, aaff_id: aaff_id, work_id: work_id || null};
      const response = await getUrlServs(data);
      const {cae, cai, finca} = response?.[0];
      const esCae = cae && id === cae.id;
      const tecnico_cae_id = response?.[0]?.tecnico_cae?.id || null;
      const tecnico_cai_id = response?.[0]?.tecnico_cai?.id || null;
      // Se actúa sobre CAE → hoja de visita interna, salvo el caso combinado
      // (CAE y CAI con el mismo técnico), que sigue yendo al app externo (grupo=1-3).
      if(esCae && (!cai || tecnico_cae_id !== tecnico_cai_id)){
        if(work_id){
          if(type === "edit"){
            window.location.href = `/hojaVisita/${finca.nif}/${work_id}/edit/${id}`;
          }else{
            window.location.href = `/hojaVisita/${finca.nif}/${work_id}/create/${id}`;
          }
        }else{
          if(type === "edit"){
            window.location.href = `/hojaVisita/${finca.nif}/edit/${id}`;
          }else{
            window.location.href = `/hojaVisita/${finca.nif}/create/${id}`;
          }
        }
      }
      else{
        const url = buildUrl(type, response, id);
        window.open(url, '_blank');
        console.log(url)
      }
      
      // window.open(response.url, '_blank');
  } catch (error) {
    console.error("Error al obtener la URL de CAE:", error);
  }
};